// Events fired only by the web app. The onboarding events are versioned to
// web's onboarding funnel 1; mobile's funnel has its own events in
// mobile-action-events.ts.
export enum WebActionEvents {
  OnboardingLifeAreasSubmit = 'onboarding_funnel_1_life_area_v1_submit',
  OnboardingGoalsSubmit = 'onboarding_funnel_1_create_goals_v1_submit',
  OnboardingGoalsSuggestionClicked = 'onboarding_funnel_1_create_goals_v2_examples_clicked',
  OnboardingHabitsSubmit = 'onboarding_funnel_1_create_habits_v1_submit',
  OnboardingTasksSubmit = 'onboarding_funnel_1_create_tasks_v1_submit',
  OnboardingWorkSituationSubmit = 'onboarding_funnel_1_work_situation_v1_submit',
  OnboardingHearAboutSubmit = 'onboarding_funnel_1_hear_about_us_v1_submit',
  OnboardingPremiumTrialSubmit = 'onboarding_funnel_1_premium_trial_start_button_clicked',
  OnboardingPremiumSkipSubmit = 'onboarding_funnel_1_premium_skip_button_clicked',
  OnboardingDesktopDownloadSubmit = 'onboarding_funnel_1_desktop_download_button_clicked',
  OnboardingDesktopSkipSubmit = 'onboarding_funnel_1_desktop_download_skip_button_clicked',
  HabitComplete = 'habit_completed',
  CancelSurveyStarted = 'cancel_survey_started',
  CancelSurveyReasonSelected = 'cancel_survey_reason_selected',
  CancelSurveyDetailSelected = 'cancel_survey_detail_selected',
  CancelSurveyCompleted = 'cancel_survey_completed',
  DeleteAccountSurveyStarted = 'delete_account_survey_started',
  DeleteAccountSurveyReasonSelected = 'delete_account_survey_reason_selected',
  DeleteAccountSurveyDetailSelected = 'delete_account_survey_detail_selected',
  DeleteAccountSurveyCompleted = 'delete_account_survey_completed',
  SetupChecklistShown = 'setup_checklist_shown',
  SetupChecklistCompleted = 'setup_checklist_completed',
  SetupChecklistDismissed = 'setup_checklist_dismissed',
}
